module.exports = __webpack_public_path__ + "static/img/purple-school.2c2d99ca.png";